/** @jsxImportSource @emotion/react */
import React from 'react';

import { Header, Page } from 'src/common/ui/components';
import { ProviderForm } from 'src/components/pages/providers/Provider.Form';

export const ProviderCreatePage = () => (
  <Page>
    <Header>Create New Provider</Header>
    <ProviderForm />
  </Page>
);
